/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Dropdown } from '@zapier/design-system';
import {
  SupportedPaymentMethod,
  PaymentSourceType,
} from '@zapier/payment/src/types';

type Props = {
  currentMethod: PaymentSourceType | null;
  onChange: (method: PaymentSourceType, hasSwitched: boolean) => void;
  supportedMethods: Array<SupportedPaymentMethod>;
};

const methodItems = {
  [PaymentSourceType.card]: {
    label: 'Debit or Credit Card',
    value: PaymentSourceType.card,
  },
  [PaymentSourceType.paypal]: {
    label: 'PayPal',
    value: PaymentSourceType.paypal,
  },
  [PaymentSourceType.bank]: {
    label: 'Bank Transfer (US Only)',
    value: PaymentSourceType.bank,
  },
  [PaymentSourceType.manual]: undefined,
};

function isNotNullish<T>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null;
}

const rootCss = css`
  min-width: 180px;
`;

const PaymentMethodSelect: React.FC<Props> = ({
  currentMethod,
  onChange,
  supportedMethods = [],
}) => {
  return (
    <div css={rootCss}>
      <Dropdown
        items={supportedMethods
          .map((m: SupportedPaymentMethod) => methodItems[m.method])
          .filter(isNotNullish)
          .filter(m => m.value !== currentMethod)}
        menuAriaLabel="List of supported payment methods"
        onChange={item => onChange(item.value, false)}
        placeholder={`${currentMethod ? 'Switch' : 'Add'} Payment Method`}
      />
    </div>
  );
};

export default PaymentMethodSelect;
